import { Injectable } from '@angular/core';
import { FirebaseApp } from '@angular/fire/app';
import { deleteInstallations, getId, getInstallations } from 'firebase/installations';

@Injectable({
  providedIn: 'root'
})
export class FirebaseInstallationsService {
  constructor(private readonly firebaseApp: FirebaseApp) {}

  public async recreateInstallationId(): Promise<void> {
    const installations = getInstallations(this.firebaseApp);
    await deleteInstallations(installations);
    await getId(installations);
  }
}
